<template>
  <div class="chart-item">
    <div class="chart-content">
      <div class="item-header" :style="headerStyle">
        <span class="header-title">{{ title }}</span>
        <div>
          <slot name="headerButton"></slot>
          <el-button v-if="hasMore" type="text" @click="$emit('handle-more')">
            {{ $t('更多') }}
          </el-button>
        </div>
      </div>
      <div class="item-chart echart-parent" v-if="options">
        <v-chart :options="options" ref="charts" :autoresize="true" />
      </div>
      <div class="item-chart" v-else-if="$slots.default">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { isArray, isEmpty, isObject } from '@/utils/is';

export default {
  name: 'chartItem',
  props: {
    title: String,
    options: {
      type: Object,
      default: () => ({})
    },
    headerStyle: {
      type: Object,
      default: () => ({})
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    smoothTimeLine: Boolean,
    smoothTimeLineMax: Number
  },
  data() {
    return {
      mixOpts: null,
      mergeOpts: null
    };
  },
  methods: {
    langChangeHandler() {
      const { options } = this;

      if (isEmpty(options.$_name)) options.$_name = options.name;

      options.name = this.translateTo(this.options.$_name);

      if (!isEmpty(options.yAxis?.name)) {
        if (isEmpty(options.yAxis.$_name)) options.yAxis.$_name = options.yAxis.name;

        options.yAxis.name = this.translateTo(options.yAxis.$_name);
      }

      if (!isEmpty(options.xAxis?.name)) {
        if (isEmpty(options.xAxis.$_name)) options.xAxis.$_name = options.xAxis.name;

        options.xAxis.name = this.translateTo(options.xAxis.$_name);
      }

      if (isArray(options.series)) {
        options.series.forEach(e => {
          if (e.name) {
            if (isEmpty(e.$_name)) e.$_name = e.name;
            e.name = this.translateTo(e.$_name);
          }

          if (e.type === 'gauge' && isArray(e.data)) {
            e.data.forEach(e => {
              if (e.name) {
                if (isEmpty(e.$_name)) e.$_name = e.name;
                e.name = this.translateTo(e.$_name);
              }
            });
          }
        });
      } else if (isObject(options.series)) {
        if (options.series.name) {
          if (isEmpty(options.series.$_name)) options.series.$_name = options.series.name;
          options.series.name = this.translateTo(options.series.$_name);
        }
      }

      if (!isEmpty(options.legend) && isArray(options.legend.data)) {
        if (isEmpty(options.legend.$_data)) {
          options.legend.$_data = [...options.legend.data];
        }

        options.legend.data = options.legend.$_data.map(e => this.translateTo(e));
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.langChangeHandler();
    });
  }
};
</script>

<style lang="scss">
.chart-item {
  flex: 1;
  height: 100%;
  min-height: 25%;
  max-height: 33%;

  @include border-style-1;

  overflow: hidden;
  .chart-content {
    height: 100%;
  }
  .item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgb(72, 156, 214);
    height: 15%;
    padding: 0 10px;
    .header-title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .value-show {
      span {
        font-size: 12px;
        margin: 0 2px;
        padding: 0 2px;
        border-radius: 4px;
        background-color: rgba(0, 14, 13, 0.6);
      }
    }
  }
  .item-chart {
    height: 85%;
  }
}
</style>
